import Layer from "./Layer.js";

/**
 *
 * @param {Spinner} spinner
 * @param {HTMLElement} node
 * @param {HTMLElement} [subjectNode]
 * @class
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ViewerLayer(spinner, node, subjectNode) {
  this.widthPropName = null;
  this.heightPropName = null;
  Layer.call(this, spinner, node, subjectNode);
}

ViewerLayer.prototype = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __proto__: Layer.prototype,

  setSubject(subject) {
    Layer.prototype.setSubject.call(this, subject);

    if (this.subject instanceof HTMLVideoElement) {
      this.widthPropName = "videoWidth";
      this.heightPropName = "videoHeight";
    } else {
      this.widthPropName = "naturalWidth";
      this.heightPropName = "naturalHeight";
    }
  },

  get subjectWidth() {
    return this.subject[this.widthPropName] || this.subject.offsetWidth;
  },

  get subjectHeight() {
    return this.subject[this.heightPropName] || this.subject.offsetHeight;
  },
};
